import { Routes } from '@angular/router';
import { PortfolioComponent } from './components/portfolio/portfolio';
import { KanbanComponent } from './components/kanban/kanban';
import { ProjectDetail } from './components/project-detail/project-detail';
import { LoginComponent } from './components/login/login'; 
import { authGuard } from './guards/auth-guard';

export const routes: Routes = [
  { path: 'portfolio', component: PortfolioComponent, title: 'Nicolai | Portfolio' },
  { path: 'portfolio/:id', component: ProjectDetail, title: 'Nicolai | Project' }, 
  { path: 'kanban', component: KanbanComponent, canActivate: [authGuard], title: 'Admin | Kanban' }, 
  { path: 'login', component: LoginComponent, title: 'Admin | Login' }, 
  { path: 'project/:id', component: ProjectDetail, canActivate: [authGuard], title: 'Admin | Edit' },
  { path: '', redirectTo: '/portfolio', pathMatch: 'full' }
];
